import {
  BaseOptions,
  Weblog,
  LoggerConfigByUser,
  PVOptions,
  ShowOptions,
  TaskOptions,
  CustomOptions,
} from '@ks/weblogger';
import { useEffect, useState } from 'react';
import { cookie } from '@/client/utils/methods/common';

// 这个环境变量是webpack打包时注入的，不是在环境中进行配置
const { API_ENV } = process.env;
const isProd = API_ENV === 'production';

export class OverseaLog {
  public logger: Weblog;

  private overseaBaseConfig: BaseOptions = {
    version_name: cookie.getItem('appver') || '',
    network_type: (cookie.getItem('net') || 'unknown') as NetworkType,
    channel: cookie.getItem('c') || '',
    product_name: 'KWAI_BULLDOG',
    package_name: '',
    user_id: cookie.getItem('ud') || '',
  };

  private overseaLogConfig: LoggerConfigByUser = {
    env: isProd
      ? 'https://g-logsdk.snackvideo.com/rest/wd/common/log/collect/misc2'
      : `${window.location.origin}/rest/wd/common/log/collect/misc2`,
    autoPV: false,
    // logger: !isProd,
  };

  constructor(logConfig: LoggerConfigByUser = {}, baseConfig: BaseOptions = {}) {
    const totalLogConfig = { ...this.overseaLogConfig, ...logConfig };
    const totalBaseConfig = { ...this.overseaBaseConfig, ...baseConfig };
    this.logger = new Weblog(totalLogConfig, totalBaseConfig);
  }

  public sendPv(pvOptions: PVOptions) {
    this.logger.sendImmediately('PV', pvOptions);
  }

  public sendShow(showOptions: ShowOptions) {
    this.logger.sendImmediately('SHOW', showOptions);
  }

  public sendClick(taskOptions: TaskOptions) {
    this.logger.sendImmediately('CLICK', taskOptions);
  }

  public sendCustom(customOptions: CustomOptions) {
    this.logger.sendImmediately('CUSTOM', customOptions);
  }
}

const useWeblog = (
  logConfig: LoggerConfigByUser = {},
  baseConfig: BaseOptions = {},
  cb?: (overseaLog: OverseaLog) => void,
) => {
  const [weblog, setWeblog] = useState<OverseaLog>();
  useEffect(() => {
    const overseaLog = new OverseaLog(logConfig, baseConfig);
    cb && cb(overseaLog);
    setWeblog(overseaLog);
  }, []);
  return weblog;
};

type NetworkType = 'unknown' | 'none' | 'wifi' | '4g' | '3g' | '2g';

export default useWeblog;
